import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  MessageChannel,
  MessageTemplateDto,
  SmsTestRequest,
} from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';
import { TemplateVariableDefinitionDto } from '@/features/dashboard/messageTemplates/types/TemplateVariableDefinitionDto.ts';

const messageTemplatesApi = {
  getAll: async (channel: MessageChannel): Promise<MessageTemplateDto[]> => {
    return await fetchPrivateApi<MessageTemplateDto[]>(
      'GET',
      `message-templates/${channel}`,
    );
  },

  getVariables: async (
    channel: MessageChannel,
    type: string,
  ): Promise<TemplateVariableDefinitionDto[]> => {
    return await fetchPrivateApi<TemplateVariableDefinitionDto[]>(
      'GET',
      `message-templates/${channel}/${type}/variables`,
    );
  },

  updateTemplate: async (
    channel: MessageChannel,
    type: string,
    body: MessageTemplateDto,
  ): Promise<MessageTemplateDto> => {
    return await fetchPrivateApi<MessageTemplateDto>(
      'PUT',
      `message-templates/${channel}/${type}`,
      body,
    );
  },

  getDefaultTemplate: async (
    channel: MessageChannel,
    type: string,
  ): Promise<MessageTemplateDto> => {
    return await fetchPrivateApi<MessageTemplateDto>(
      'GET',
      `message-templates/${channel}/${type}/default`,
    );
  },

  sendTestEmail: async (
    type: string,
    body: MessageTemplateDto,
  ): Promise<void> => {
    await fetchPrivateApi<void>(
      'POST',
      `message-templates/EMAIL/${type}/test/email`,
      body,
    );
  },

  sendTestSms: async (type: string, body: SmsTestRequest): Promise<void> => {
    await fetchPrivateApi<void>(
      'POST',
      `message-templates/SMS/${type}/test/sms`,
      body,
    );
  },
};

export default messageTemplatesApi;
